import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter-checkbox"
export default class extends Controller {
  connect() {
    this.element.addEventListener("change", this.onToggleFilterCheckbox)
  }

  disconnect() {
    this.element.removeEventListener("change", this.onToggleFilterCheckbox)
  }

  onToggleFilterCheckbox(event) {
    this.form.requestSubmit(document.getElementById(this.submitterId));
    const label = this.closest('label');
    if (event.target.checked) {
      label.classList.add('--selected');
    } else {
      label.classList.remove('--selected');
    }
  }
}